export const formatAudioSource = (source: string) => {
  const sourceObject = new URL(source)
  if (source.includes('ausha.co')) {
    // Ausha SmartPlayer is responsive by default
    // and the height occupied by the player is 500px on xs screens and 220px on others
    // Both playlist and display params break responsiveness
    sourceObject.searchParams.delete('playlist')
    sourceObject.searchParams.delete('display')
  }

  // Unfortunately, RCF player and Ausha player don't support autoplay
  sourceObject.searchParams.set('auto_play', 'true')

  return sourceObject
}
